/**
 * @generated SignedSource<<b2cfd6e9cbdf2cb5c53895c8232a70c7>>
 * @relayHash 2aa63a63379e29b0c62edcd766e7eec4
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2aa63a63379e29b0c62edcd766e7eec4

import { ConcreteRequest } from 'relay-runtime';
export type De_undoDuplicatePatientsInput = {
  primaryPatientId: string;
};
export type deUndoDuplicatePatientsMutation$variables = {
  input: De_undoDuplicatePatientsInput;
};
export type deUndoDuplicatePatientsMutation$data = {
  readonly de_undoDuplicatePatients: {
    readonly de_Patient: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deUndoDuplicatePatientsMutation = {
  response: deUndoDuplicatePatientsMutation$data;
  variables: deUndoDuplicatePatientsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "de_Patient",
  "kind": "LinkedField",
  "name": "de_Patient",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deUndoDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_undoDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "de_undoDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deUndoDuplicatePatientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "De_undoDuplicatePatientsPayload",
        "kind": "LinkedField",
        "name": "de_undoDuplicatePatients",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2aa63a63379e29b0c62edcd766e7eec4",
    "metadata": {},
    "name": "deUndoDuplicatePatientsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "7698ce3437a656e1bcd9ecf4f8dd7125";

export default node;
